var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.theUrl)?_c('video',{ref:"video",attrs:{"controls":"","width":"400","height":"360"}},[_c('source',{attrs:{"src":'https://api.my.ug.edu.ge/api/openVideo?filePath='+_vm.theUrl+'&token='+_vm.token,"type":"video/mp4"}}),_vm._v(" Your browser does not support the video tag. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }